type CommunityFooterProps = {
  brandHref: string;
  className?: string;
  keepCurrentView?: boolean;
};

export function CommunityFooter({
  brandHref,
  className = "",
  keepCurrentView = false,
}: CommunityFooterProps) {
  return (
    <footer
      className={`participant-community-footer ${className}`.trim()}
    >
      <a
        aria-label="Hello World UNAM"
        className="community-footer-brand"
        href={brandHref}
        onClick={(event) => {
          if (
            keepCurrentView &&
            event.button === 0 &&
            !event.metaKey &&
            !event.ctrlKey &&
            !event.shiftKey &&
            !event.altKey
          ) {
            event.preventDefault();
          }
        }}
      >
        <span className="community-footer-mark">
          <img alt="" aria-hidden="true" src="/helloworld-mark.png" />
        </span>
        <span className="community-footer-wordmark">
          <strong>
            HELLO <em>WORLD</em>
          </strong>
          <small>COMUNIDAD · COMPETENCIA · CRECIMIENTO</small>
        </span>
      </a>
      <nav aria-label="Hello World en internet" className="community-footer-social">
        <a
          aria-label="Instagram de Hello World"
          className="community-social-link community-social-link--instagram"
          href="https://www.instagram.com/helloworld_unam/"
          rel="noreferrer"
          target="_blank"
        >
          <img alt="" aria-hidden="true" src="/social/instagram.svg" />
          <span>Instagram</span>
        </a>
        <a
          aria-label="Sitio web de Hello World"
          className="community-social-link community-social-link--website"
          href="https://helloworld-unam.tech/"
          rel="noreferrer"
          target="_blank"
        >
          <img alt="" aria-hidden="true" src="/social/website.svg" />
          <span>Sitio web</span>
        </a>
        <a
          aria-label="LinkedIn de Hello World"
          className="community-social-link community-social-link--linkedin"
          href="https://www.linkedin.com/in/hello-world-5243573b5/"
          rel="noreferrer"
          target="_blank"
        >
          <img alt="" aria-hidden="true" src="/social/linkedin.svg" />
          <span>LinkedIn</span>
        </a>
      </nav>
    </footer>
  );
}
